module.exports = __webpack_public_path__ + "img/forBusiness.9e60dab1.svg";